/**
 * TSS logs Admin API
 * TSS logs Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Defines meta-data-summary for TSS logs
 */
export interface MetaDataSummaryDTO { 
    id?: string;
    tenantId: string;
    businessPremisesId?: string;
    /**
     * Represents the internal id of the associated organization
     */
    organizationId?: string;
    fccId: string;
    /**
     * Represents the internal id of the TSS entity
     */
    tssId: string;
    tssSerialNumber: string;
    /**
     * time of the latest upload into Fiskal Cloud
     */
    lastExportTime?: string;
    /**
     * Creation date
     */
    createdDate?: string;
    /**
     * Date of last change
     */
    lastModifiedDate?: string;
    /**
     * Created by
     */
    createdBy?: string;
    /**
     * Last modified by
     */
    lastModifiedBy?: string;
}

export class ClsMetaDataSummaryDTO { 
    id?: string = undefined;
    tenantId: string = undefined;
    businessPremisesId?: string = undefined;
    /**
     * Represents the internal id of the associated organization
     */
    organizationId?: string = undefined;
    fccId: string = undefined;
    /**
     * Represents the internal id of the TSS entity
     */
    tssId: string = undefined;
    tssSerialNumber: string = undefined;
    /**
     * time of the latest upload into Fiskal Cloud
     */
    lastExportTime?: string = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
    /**
     * Date of last change
     */
    lastModifiedDate?: string = undefined;
    /**
     * Created by
     */
    createdBy?: string = undefined;
    /**
     * Last modified by
     */
    lastModifiedBy?: string = undefined;
}

